import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/lessons-admin.action'

import getLesson from '../../../api/administration/lessons/Get'

async function handleGetLesson(lessonId: number) {
  return await getLesson(lessonId)
}

function* getLessonEffectSaga(action: any) {
  try {
    const data = yield call(handleGetLesson, action.lessonId)
    yield put(fromActions.Actions.getLessonSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* getLessonWatcherSaga() {
  yield takeLatest(fromActions.GET_LESSON, getLessonEffectSaga)
}
